export { default as theme } from './theme';

const styles = undefined;

export default styles;
